import React, { useEffect, useRef, useState } from "react";
import "./SectionThree.css";

import sectionPaper from "../../assets/ss.png";
import heartArabicGroup from "../../assets/Group15.png";
import rightHalim from "../../assets/holmyholm2.png";
import roseImg from "../../assets/rose2.png";
import leftPlayer from "../../assets/holmyholm.png";
import eyesQuoteGroup from "../../assets/Group16.png";
import envelopeImg from "../../assets/zarf.png";
import centerPhotos from "../../assets/Group2.png";

const SectionThree = () => {
  const sectionRef = useRef(null);
  const [showSection, setShowSection] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowSection(true);
          observer.unobserve(currentSection);
        }
      },
      {
        threshold: 0.22,
      }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  return (
    <section
      className={`sectionThree ${showSection ? "showSectionThree" : ""}`}
      id="images"
      ref={sectionRef}
    >
      <div className="sectionThreeWrap">
        <img
          src={sectionPaper}
          alt="paper background"
          className="sectionThreePaper"
        />

        <img
          src={heartArabicGroup}
          alt="heart and arabic title"
          className="sectionThreeHeartArabicGroup"
        />

        <img
          src={rightHalim}
          alt="Abdel Halim right"
          className="sectionThreeRightHalim"
        />

        <img
          src={leftPlayer}
          alt="Abdel Halim playing"
          className="sectionThreeLeftPlayer"
        />

        <img
          src={centerPhotos}
          alt="center photos"
          className="sectionThreeCenterPhotos"
        />

        <img
          src={envelopeImg}
          alt="envelope"
          className="sectionThreeEnvelope"
        />

        <img
          src={eyesQuoteGroup}
          alt="eyes and quote group"
          className="sectionThreeEyesQuoteGroup"
        />

        <img
          src={roseImg}
          alt="rose"
          className="sectionThreeRose"
        />
      </div>
    </section>
  );
};

export default SectionThree;